// apolo/src/lib/generativeIntent.js — P0-T06 (software-to-9).
//
// Strict classifier for "one-shot creative build" intent — the ONLY case where the
// generative fast mode is allowed to relax governance (skip the AUTO_CORRECT
// RED→re-run verifier loop). DELIBERATELY CONSERVATIVE: default GOVERNED. Any
// code-maintenance signal (fix/refactor/test/lint/debug/endpoint/deploy) → false,
// so real code work can NEVER be fast-pathed even if a caller wrongly opts in.
// (DECISIONS Q7 — the governance boundary.)
//
// PURE: no imports, no I/O. The teeth live in generativeIntent.test.js.

// Code-maintenance signals — if ANY is present, the turn is GOVERNED (never fast).
// Checked FIRST so "refatore o site" / "corrija a landing page" stay governed.
const CODE_MAINTENANCE_RE = new RegExp(
  [
    'corrij', 'consert', 'refator', '\\bdebug', '\\bbug\\b', '\\bteste?s?\\b', 'testar',
    '\\blint\\b', 'endpoint', '\\bapi\\b', '\\bfix\\b', 'refactor', 'migrat', 'deploy',
    'remov', '\\berro\\b', '\\berror\\b', 'falh', 'quebr', 'stack\\s*trace',
  ].join('|'),
  'i',
);

// Creative BUILD verbs — the user is asking to make a new artifact from scratch.
const CREATIVE_BUILD_VERB_RE = new RegExp(
  ['\\bcrie\\b', '\\bcriar\\b', '\\bcria\\b', '\\bfa[çc]a\\b', '\\bgere\\b', '\\bgera\\b',
    '\\bmonte\\b', '\\bmontar\\b', '\\bconstrua\\b', '\\bdesenhe\\b',
    '\\bbuild\\b', '\\bcreate\\b', '\\bmake\\b', '\\bgenerate\\b', '\\bdesign\\b'].join('|'),
  'i',
);

// Visual artifact nouns — clearly a UI surface (ambiguous "componente" excluded).
const ARTIFACT_NOUN_RE = new RegExp(
  ['landing\\s*page', 'p[áa]gina', '\\bsite\\b', 'website', 'webpage', '\\bhero\\b',
    'dashboard', 'portfolio', 'mockup', 'prot[óo]tipo', '\\btela\\b', 'interface', '\\blp\\b'].join('|'),
  'i',
);

/**
 * isGenerativeCreativeIntent(text) → boolean.
 * True ONLY for a clearly-creative single-turn build of a visual artifact, with no
 * code-maintenance signal. Conservative by design (default false → governed).
 * @param {string} text
 */
export function isGenerativeCreativeIntent(text) {
  const t = typeof text === 'string' ? text : '';
  if (!t.trim()) return false;
  if (CODE_MAINTENANCE_RE.test(t)) return false; // any maintenance signal → governed
  return CREATIVE_BUILD_VERB_RE.test(t) && ARTIFACT_NOUN_RE.test(t);
}

export default { isGenerativeCreativeIntent };
